import * as React from "react";
import cx from "classnames";
import { WrappedComponentProps, injectIntl } from "react-intl";

const styles = require("./smallFollowButton.scss");
interface IProps extends WrappedComponentProps {
  isFollowing: boolean;
  onFollow: () => void;
  onUnFollow: () => void;
}

const SmallFollowButton: React.FC<IProps> = ({
  isFollowing,
  onFollow,
  onUnFollow,
  intl,
}) => {
  const stateData = isFollowing
    ? {
        className: styles.following,
        messageId: "following",
      }
    : {
        className: null,
        messageId: "follow",
      };

  return (
    <button
      className={cx(styles.smallFollowButton, stateData.className)}
      onClick={isFollowing ? onUnFollow : onFollow}
    >
      <span className={styles.label}>
        {intl.formatMessage({ id: stateData.messageId })}
      </span>
    </button>
  );
};

export { SmallFollowButton as Pure };
export default injectIntl(SmallFollowButton);
